<template>
	<el-container>
		<el-main style="width: 80%;">
			<div style="margin-bottom: 30px;">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="item_font">开口机器人</el-breadcrumb-item>
					<el-breadcrumb-item><span class="item_font">话术编辑</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<div class="corpusData" style="display: flex;flex-direction: row;justify-content: flex-start;align-items: flex-start;">
				<div class="tree-scroller">
					<div class="content_left" style="width: 20%;">
						<el-tree :data="themeLst" highlight-current :indent="18" node-key="id" :expand-on-click-node="false" @node-click="handleNodeClick">
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span :class="data.pId=='0'?'node_class1':'node_class2'" class="item_font">{{ node.label }}</span>
							</span>
						</el-tree>
					</div>
				</div>
				
				<div class="content_right" style="width: 70%;display: flex;flex-direction: column;align-items: flex-start;">
					<!-- <div></div> -->
					<div class="radios" style="display: flex;flex-direction: row;justify-content: space-between;width: 100%;height: 30px;line-height: 30px;font-size: 14px;">
						<el-radio-group v-model="tabSelect" size="mini" @change="tabChange">
							<el-radio-button v-for="(item,index) in tabs" :key="index" :label="item.label">{{item.text}}</el-radio-button>
						</el-radio-group>
						<el-button type="primary" size="mini" @click="addClick" class="item_font">新增</el-button>
					</div>
					<div class="table_page" style="display: flex;flex-direction: column;justify-content: flex-start;align-items: center;width: 100%;margin-top: 1.875rem;">
						<el-table :data="corpusData" :header-cell-style="headerStyle" border :cell-style="cellStyle" :max-height="500"
						style="width: 100%;">
							<el-table-column prop="content" label="话术"></el-table-column>
							<el-table-column label="操作" width="120" fixed="right">
								<template slot-scope="scope">
									<el-button @click="handleClick(scope.row)" type="text" size="small" class="item_font">删除</el-button>
									<el-button type="text" size="small" @click="editClick(scope.row)" class="item_font">编辑</el-button>
								</template>
							</el-table-column>

						</el-table>
						<div style="display: flex;flex-direction: row;width: 60%;margin-left: 10%;margin-top: 3%;justify-content: space-around;">
							<el-pagination background :pager-count='9' :page-size="10" layout="prev, pager, next, total" :total="total"
							@prev-click="pre" @next-click="next" @current-change="handleCurrentChange"> </el-pagination>
						</div>
					</div>
				</div>

			</div>
			<div v-show="add">
				<el-dialog :title="addQueryTitle.title" style="height: 470px;" :visible.sync="add" custom-class="dialog"
				:close-on-click-modal="false" :close-on-press-escape="false" width="30%" center>
					<div style="height: 100px;">
						<el-input type="textarea" cols="2" rows="4" placeholder="请输入内容" v-model="inputValue">
						</el-input>
					</div>
					<div slot="footer" class="dialog-footer">
						<el-button @click="add = false" class="item_font">取 消</el-button>
						<el-button type="primary" @click="confirm(addQueryTitle.type)" class="item_font">确 定</el-button>
					</div>
				</el-dialog>
			</div>
		</el-main>
	</el-container>
</template>

<script>
	import {
		MessageBox
	} from 'element-ui';
	export default {
		name: 'corpus',
		data() {
			return {
				exampleQes: "便秘应该怎么办",
				tabSelect: 2,
				corpusDataValue: "2",
				overIndex: 0,
				themeLst: [],
				total: 0,
				clickedTopicData: {
					type: 0,
					topicId: ""
				},
				startTopic: "",
				page: 1,
				corpusData: [],
				showData: [],
				tabs: [{
					label: 2,
					text: "专业话术"
				}, {
					label: 3,
					text: "一般话术"
				}, {
					label: 4,
					text: "关怀话术"
				}, {
					label: 5,
					text: "提醒话术"
				}],
				add: false,
				addQueryTitle: {
					title: '',
					type: ""
				},
				inputValue: "",
				editTalkForm: {
					"id": "",
					"type": 0,
					"topicId": "",
					"content": "",
					"orderNum": 0,
					"flag": 0,
					"createId": "",
					"updateId": ""
				},
				talkDeleteForm: {
					ids: []
				}
			}
		},
		mounted() {
			this.topicTreeSelect()
		},
		methods: {
			headerStyle({
				rowIndex,
				columnIndex
			}) {
				if (rowIndex==0&&columnIndex==1) {
					return 'text-align:left;padding:15px;color:#000000';
				} else {
					return 'text-align:center;color:#000000'
				}

			},
			cellStyle({
				columnIndex
			}) {
				if (columnIndex == 0) {
					return 'text-align:left;padding:15px;';
				} else {
					return 'text-align:center'
				}
			},
			// 查询话题树
			async topicTreeSelect() {
				var api = "/manager/topic/selectTree"
				const response = await this.util.postRequest({
					itype: "1",
					url: api,
					method: "POST",
					data: {
						userId: this.util.getLocalAccount().id
					}
				})
				if (response.resultCode == "10000") {
					for (var i = 0; i < response.data.length; i++) {
						this.getTree(response.data[i])
					}
					this.themeLst = response.data
					if (this.startTopic == "") {
						this.startTopic = response.data[0].id
						this.$nextTick().then(() => {
							const firstNode = document.querySelector('.el-tree-node')
							firstNode.click()
						})
					}
				}
			},

			getTree(data) {
				data.label = data.name
				// data.pid = data.pid
				if (data.children != null) {
					for (var i = 0; i < data.children.length; i++) {
						this.getTree(data.children[i])
					}
				}
			},

			// 点击树节点展示数据
			handleNodeClick(data) {
				this.clickedTopicData.topicId = data.id
				console.log(data.id)
				this.clickedTopicSelect()
			},
			async clickedTopicSelect() {
				this.clickedTopicData.type = this.tabSelect
				var api = "/manager/talkCorpus/selectTalks"
				const response = await this.util.postRequest({
					itype: "1",
					url: api,
					method: "POST",
					data: this.clickedTopicData
				})
				this.corpusData = response.data
				this.total = this.corpusData.length
				this.showData = this.corpusData.slice((this.page - 1) * 10, this.page * 10 - 1)
			},

			// 切换tab展示数据
			tabChange() {
				this.clickedTopicSelect()
			},

			canDel(item, index) {
				this.overIndex = index
				console.log("悬停在哪了", index)
			},
			cannotDel(item, index) {
				this.overIndex = index
				console.log("我走了")
			},
			// 分页相关方法
			pre(info) {
				console.log("pre：", info)
				this.page = info
				this.showData = this.corpusData.slice((this.page - 1) * 10, this.page * 10 - 1)
			},
			next(info) {
				console.log("next：", info)
				this.page = info
				this.showData = this.corpusData.slice((this.page - 1) * 10, this.page * 10 - 1)
			},
			handleCurrentChange(val) {
				this.start = 4 * (val - 1)
				this.page = val
				this.showData = this.corpusData.slice((this.page - 1) * 10, this.page * 10 - 1)
			},
			addClick() {
				//新增话术按钮
				this.addQueryTitle.title = "新增话术"
				this.addQueryTitle.type = "add"
				this.inputValue = ""
				this.add = true

			},
			editClick(row) {
				//编辑话术按钮
				this.editTalkForm.id = row.id
				this.addQueryTitle.title = "编辑话术"
				this.addQueryTitle.type = "edit"
				this.inputValue = row.content
				this.add = true
			},
			async confirm(type) {
				if (this.inputValue.replace(/\s+/g, "") === "") {
					const text = "话术不能为空"
					MessageBox.alert(text, "提示", {
						confirmButtonText: "确定",
						cancelButtonText: null,
						type: "warning",
						showCancelButton: false,
					});
				} else {
					this.editTalkForm.type = this.tabSelect
					this.editTalkForm.topicId = this.clickedTopicData.topicId
					this.editTalkForm.content = this.inputValue
					var api = "/manager/talkCorpus/edit"
					const response = await this.util.postRequest({
						itype: "1",
						url: api,
						method: "POST",
						data: this.editTalkForm
					})
					if (response.resultCode == "10000" && type == "edit") {
						this.add = false
						this.editTalkForm.id = ""
						this.clickedTopicSelect()
					} else if (response.resultCode == "10000" && type == "add") {
						this.add = false
						this.editTalkForm.id = ""
						this.clickedTopicSelect()
						
					} else {
						this.$message.error(response.desc)
					}
				}

			},
			async handleClick(row) {
				this.talkDeleteForm.ids.push(row.id)
				console.log(this.deleteId)
				MessageBox.alert("是否确认删除", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					showCancelButton: true,
				}).then(() => {
					this.deleteTalk()
				}).catch(() => {
					this.talkDeleteForm.ids = []
				})
			},
			async deleteTalk() {
				var api = "/manager/talkCorpus/deleteByIds"
				const response = await this.util.postRequest({
					itype: "1",
					url: api,
					method: "POST",
					data: this.talkDeleteForm
				})
				if (response.resultCode == "10000") {
					this.talkDeleteForm.ids = []
					this.clickedTopicSelect()
					
				} else {
					this.$message.error(response.desc)
				}
			}

		}
	}
</script>

<style scoped>

	.node_class1 {
		font-size: 16px;
		/* font-weight: 550; */
	}

	.node_class2 {
		font-size: 14px;
	}
	
	.tree-scroller{
		height: 37.5rem;
		overflow: -moz-scrollbars-none;
		overflow: -moz-scrollbars-none;
		overflow-y: scroll;
	}
	
	.tree-scroller::-webkit-scrollbar{
		display: none;
	}
</style>
